import { styled } from '@mui/material/styles';
import { Box, Paper, TableRow, Chip } from '@mui/material';

export const PageContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  minHeight: '100vh',
  backgroundColor: theme.palette.background.default,
}));

export const ContentWrapper = styled(Box)({
  maxWidth: '1200px',
  margin: '0 auto',
  padding: '32px 24px',
});

export const Header = styled(Box)({
  marginBottom: '28px',
});

export const OrgBadge = styled(Chip)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '0.75rem',
  marginTop: '8px',
  backgroundColor: theme.palette.action.selected,
  color: theme.palette.text.primary,
}));

export const TablePaper = styled(Paper)(({ theme }) => ({
  borderRadius: 12,
  overflow: 'hidden',
  boxShadow: theme.shadows[2],
}));

export const ClickableRow = styled(TableRow)(({ theme }) => ({
  cursor: 'pointer',
  transition: 'background-color 0.15s ease',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:last-child td': {
    borderBottom: 0,
  },
}));

export const LanguageChip = styled(Chip)({
  fontSize: '0.7rem',
  height: 22,
  fontWeight: 600,
  textTransform: 'uppercase',
});

export const DescriptionText = styled(Box)({
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  fontSize: '0.8rem',
  lineHeight: 1.4,
});
